import React from 'react';
import { MissionIdParams } from '@src/core/entities';
import { useParams } from 'react-router-dom';
import { useGetOrderMissionQuery } from '@src/features/order/redux';
import { OrderMissionEntity } from '@src/core/features';
import { ArcDroneMarker, ArcPolyline, DestinationMarker, DistanceLabel } from '@src/core/controllers';

const getOrderWP = (data: OrderMissionEntity) => {
  const orderWP = data.waypoints.find((w) => Boolean(w.orderId));
  return orderWP;
};

const getTakeOff = (data: OrderMissionEntity) => {
  const [wp] = data.waypoints;
  return wp;
};

const ConfirmOrderMap: React.FC = () => {
  const { missionId } = useParams<MissionIdParams>();
  const { data, isLoading } = useGetOrderMissionQuery(missionId);

  if (isLoading || !data) return null;

  const order = getOrderWP(data);
  const drone = getTakeOff(data);

  const initialPath = data?.waypoints?.map((w) => ({
    lat: Number(w.latitude),
    lng: Number(w.longitude),
  }));

  const droneLat = Number(drone?.latitude);
  const droneLng = Number(drone?.longitude);
  const orderLat = Number(order?.latitude);
  const orderLng = Number(order?.longitude);

  const distancePath = [
    { lat: droneLat, lng: droneLng },
    { lat: orderLat, lng: orderLng },
  ];

  return (
    <React.Fragment>
      <DestinationMarker.pending 
        position={{ 
          lat: orderLat, 
          lng: orderLng, 
        }} />
        
      <ArcDroneMarker.idleSelected 
        position={{ 
          lat: droneLat, 
          lng: droneLng, 
        }}  
      />

      <ArcPolyline.future path={initialPath}  />

      {!isNaN(droneLat) && !isNaN(droneLng) && !isNaN(orderLat) && !isNaN(orderLng) && (
        <DistanceLabel path={distancePath} />
      )}
    </React.Fragment>
  );
};

export default ConfirmOrderMap;